// removed by extract-text-webpack-plugin
module.exports = {"RedCircle":"Game__RedCircle__2N8jP","ReminderSection":"Game__ReminderSection__3WXgC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Game/Game.css
// module id = 411
// module chunks = 0